import type { RiskScoringSettingsLang } from '@risksmart-app/atomic-ui';
import type { TFunction } from 'i18next';

export const buildLang = (
  t: TFunction<'common', 'riskScoringSettings'>
): RiskScoringSettingsLang => ({
  alert: {
    title: t('alert.title'),
    subtitle: {
      impactLikelihood: t('alert.subtitle.impactLikelihood'),
      multiImpact: t('alert.subtitle.multiImpact'),
    },
    description: {
      default: t('alert.description.default'),
      pending: t('alert.description.pending'),
    },
  },
  page: {
    header: t('page.header'),
    description: t('page.description'),
  },
  impactLikelihoodCard: {
    title: t('impactLikelihoodCard.title'),
    description: t('impactLikelihoodCard.description'),
    selectedAlertText: t('impactLikelihoodCard.selectedAlertText'),
    selectedBadgeText: t('impactLikelihoodCard.selectedBadgeText'),
    setupBadgeText: t('impactLikelihoodCard.setupBadgeText'),
  },
  multiImpactCard: {
    title: t('multiImpactCard.title'),
    description: t('multiImpactCard.description'),
    selectedAlertText: t('multiImpactCard.selectedAlertText'),
    selectedBadgeText: t('multiImpactCard.selectedBadgeText'),
    setupBadgeText: t('multiImpactCard.setupBadgeText'),
    unselectedAlertText: t('multiImpactCard.unselectedAlertText'),
    unselectedBadgeText: t('multiImpactCard.unselectedBadgeText'),
  },
  likelihoodLevels: {
    title: t('likelihoodLevels.title'),
    description: t('likelihoodLevels.description'),
    addButton: t('likelihoodLevels.addButton'),
  },
  impactLevels: {
    title: t('impactLevels.title'),
    description: t('impactLevels.description'),
    addButton: t('impactLevels.addButton'),
  },
  matrix: {
    title: t('matrix.title'),
    description: t('matrix.description'),
    alert: {
      description: t('matrix.alert.description'),
    },
  },
  invertMatrixToggle: {
    title: t('invertMatrixToggle.title'),
    checked: t('invertMatrixToggle.checked'),
    unchecked: t('invertMatrixToggle.unchecked'),
  },
  impactCategories: {
    title: t('impactCategories.title'),
    description: t('impactCategories.description'),
    addButton: t('impactCategories.addButton'),
  },
  impactAggregation: {
    title: t('impactAggregation.title'),
    description: {
      average: t('impactAggregation.description.average'),
      maximum: t('impactAggregation.description.maximum'),
    },
    averageLabel: t('impactAggregation.averageLabel'),
    maximumLabel: t('impactAggregation.maximumLabel'),
  },
});
